<div class="spinnerContainer">
    <div class="spinnerContainer-content">
        <div>
            <span class="spinnerContainer-loader"></span>
        </div>
        <span>{{ 'bancolombia-Bnpl-redirect' | translation | async }}</span>
    </div>
</div>